import { render } from "./BlockDivider.vue?vue&type=template&id=77def161&scoped=true"
const script = {}

import "./BlockDivider.vue?vue&type=style&index=0&id=77def161&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77def161"]])

export default __exports__